export const getUrl = (location: { pathname: string }, urlPath: string) => {
  return `${location.pathname === "/en-US" ? "/us" : ""}/shop/${urlPath
    .split("/")
    .filter((item) => item !== "us")
    .join("/")}`
}
